export class ConfirmationDialogModel {
  size?: string;
  message!: string;
  cancelButtonText?: string;
  okButtonText!: string;
}
